import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import { Grid } from "@mui/material";
import Table from "@mui/material/Table";
import { LinearProgress } from "@mui/material";
import Button from "@mui/material/Button";
import { Input } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import axios from "../../Uri";
import Card from "react-bootstrap/Card";
import { Col, Row, Container } from "react-bootstrap";
import jsPDF from "jspdf";
import Moment from "moment";

import {getLoginHistory} from '../../redux/actions/LoginAction';
import { useDispatch,useSelector } from "react-redux";
import { DownloadTableExcel } from "react-export-table-to-excel";
import "layouts/allTrasactions/scroll.css";
import { borderRadius } from "@mui/system";
function LoginHistory() {
  const tableRef = useRef(null);
  let userData = JSON.parse(sessionStorage.getItem("userdata"));
  let userId = userData.data.userId;
  console.log(userId);

  const data1 = useSelector((state)=>state.loginUser.loginData);

  console.log(data1);
  
  const [data, setData] = useState([]);
  let [pageNumber, setPageNumber] = useState(0);
  const [loader, setLoader] = useState(true);
 
  const fetchData = (pageNumber) => {

    dispatch(getLoginHistory(pageNumber))
  }

  const dispatch=useDispatch();

  useEffect(() => {

    fetchData(pageNumber);

  }, []);

  
  const columns = [
    {
      title: "User Role",
      field: "userType",
      type: "text",
      headerStyle: {
        backgroundColor: "#1E90FF",
        color: "white",
      },
      render:(rowData)=>(
        <p>{rowData.userType.toUpperCase()}</p>
      )
    },
    {
      title: "User Name",
      field: "userName",
      type: "text",
      headerStyle: {
        backgroundColor: "#1E90FF",
        color: "white",
      },
    },
    {
      title: "Login Time",
      field: "userLoggedinDate",
    },

    {
      title: "User Email",
      field: "email",
    },
  ]

  
  const loadMoreHandle = (i) => {
    let bottom =
      i.target.scrollHeight - i.target.clientHeight - i.target.scrollTop < 10;
    if (bottom) {
      let page_ = pageNumber + 1;
      fetchData(page_);
      setLoader(true);
      setPageNumber(page_);
    }
  };

  return (
    <div>
  <Grid container>

<Grid xs={12}>

  <div

    onScroll={loadMoreHandle}

    class="container"

    style={{ overflowY: "auto", height: "800px", border: "none" }}

  >

    <MaterialTable

      title="Vacated Guests From All Buildings"

      data={data1}

      sx={{ color: "white" }}

      columns={columns}

      onRowClick={async (event, rowData) => {

        await axios

          .get(`/guest/getGuestByGuestId/${rowData.id}`)

          .then((res) => {

            setGuestDetails(res.data);

            setOpen(true);

          })

          .catch((err) => {

            console.log(err);
          });
      }}
      options={{

        exportButton: true,

        pageSize: 20,

        actionsColumnIndex: -1,
paging:false,
        grouping: true,

        addRowPosition: "first",

        headerStyle: {

          backgroundColor: "#1E90FF",

          color: "white",

          fontSize: "15px",

        },

        rowStyle: {

          fontSize: 16,

        },
      }}
    />
    <br />
    <LinearProgress color="primary" />
        <h3 className="load">Loading 👱🏿‍♂️...</h3>
  </div>

</Grid>

</Grid>
    </div>
  );
}
export default LoginHistory;
